import { Funnel, Search } from 'lucide-react'

/**
 * The Progress tab's app-bar pair: funnel then magnifier.
 *
 * The funnel carries a red dot while any filter is applied — the design's
 * "Filter Applied" icon variant. Dot positioning follows the notification badge
 * on `HomeScreen`.
 *
 * Neither aria-label may match `/close/i` or `/approve/i`: the stocktake smoke
 * tests resolve both of those by accessible name elsewhere on these screens.
 */
function ProgressHeaderActions({
  filterActive,
  onFilter,
  onSearch,
}: Readonly<{ filterActive: boolean; onFilter: () => void; onSearch: () => void }>) {
  return (
    <div className="flex items-center">
      <button
        type="button"
        aria-label="Filter"
        data-tour="stocktake-progress-filter-btn"
        onClick={onFilter}
        className="relative flex size-[44px] items-center justify-center rounded-full text-foreground transition-colors hover:bg-accent"
      >
        <Funnel className="size-5" />
        {filterActive && (
          <span
            data-testid="stocktake-filter-active-dot"
            className="absolute right-2.5 top-2.5 size-2 rounded-full bg-destructive"
          />
        )}
      </button>
      <button
        type="button"
        aria-label="Search"
        data-tour="stocktake-progress-search-btn"
        onClick={onSearch}
        className="flex size-[44px] items-center justify-center rounded-full text-foreground transition-colors hover:bg-accent"
      >
        <Search className="size-5" />
      </button>
    </div>
  )
}

export { ProgressHeaderActions }
